/**
 * [@param](/user/param)  {Function}
 * [@param](/user/param)  {[Function]}  延时调用函数
 * [@param](/user/param)  {[Number]}  延迟多长时间
 * [@return](/user/return) {[Number]}  至少多长时间触发一次
 */

const config = {
  '1': {
    singleRow: 1,
    marginTop: 10,
    marginBottom: 10,
    horizCoordinateHeight: 30,
    atlas: {
      fhr: {
        range: 0
      },
      toco: true,
      ordinate: {
        x: true,
        y: true
      }
    },
    number: {
      fhr1: {
        show: true,
        fontSize: 50
      },
      fhr2: {
        show: true,
        fontSize: 50
      },
      toco: {
        show: true,
        fontSize: 50
      },
      fm: {
        show: true,
        fontSize: 35
      }
    }
  },
  '2': {
    singleRow: 2,
    marginTop: 10,
    marginBottom: 10,
    horizCoordinateHeight: 30,
    atlas: {
      fhr: {
        range: 0
      },
      toco: true,
      ordinate: {
        x: true,
        y: true
      }
    },
    number: {
      fhr1: {
        show: true,
        fontSize: 50
      },
      fhr2: {
        show: true,
        fontSize: 50
      },
      toco: {
        show: true,
        fontSize: 50
      },
      fm: {
        show: true,
        fontSize: 35
      }
    }
  },
  '4': {
    singleRow: 2,
    marginTop: 10,
    marginBottom: 10,
    horizCoordinateHeight: 30,
    atlas: {
      fhr: {
        range: 0
      },
      toco: true,
      ordinate: {
        x: true,
        y: true
      }
    },
    number: {
      fhr1: {
        show: true,
        fontSize: 50
      },
      fhr2: {
        show: true,
        fontSize: 50
      },
      toco: {
        show: true,
        fontSize: 50
      },
      fm: {
        show: true,
        fontSize: 35
      }
    }
  },
  '8': {
    singleRow: 2,
    marginTop: 10,
    marginBottom: 8,
    horizCoordinateHeight: 22,
    atlas: {
      fhr: {
        range: 2
      },
      toco: true,
      ordinate: {
        x: true,
        y: true
      }
    },
    number: {
      fhr1: {
        show: true,
        fontSize: 24
      },
      fhr2: {
        show: true,
        fontSize: 24
      },
      toco: {
        show: true,
        fontSize: 24
      },
      fm: {
        show: true,
        fontSize: 20
      }
    }
  },
  '16': {
    singleRow: 4,
    marginTop: 10,
    marginBottom: 10,
    horizCoordinateHeight: 18,
    atlas: {
      fhr: {
        range: 2
      },
      toco: true,
      ordinate: {
        x: true,
        y: false
      }
    },
    number: {
      fhr1: {
        show: true,
        fontSize: 24
      },
      fhr2: {
        show: true,
        fontSize: 24
      },
      toco: {
        show: true,
        fontSize: 24
      },
      fm: {
        show: true,
        fontSize: 20
      }
    }
  },
  // '32': {
  //   singleRow: 4,
  //   marginTop: 10,
  //   marginBottom: 10,
  //   horizCoordinateHeight: 30,
  //   atlas: {
  //     toco: false
  //   },
  //   number: {
  //     fhr1: {
  //       show: true,
  //       fontSize: 50
  //     },
  //     fhr2: {
  //       show: false,
  //       fontSize: 50
  //     },
  //     toco: {
  //       show: false,
  //       fontSize: 50
  //     },
  //     fm: {
  //       show: false,
  //       fontSize: 35
  //     }
  //   }
  // }
  wave: {
    fhr1: {
      color: '#ff6f73',
      lineWidth: 1,
      opacity: 1
    },
    fhr2: {
      color: '#ffba6f',
      lineWidth: 1,
      opacity: 1
    },
    toco: {
      color: '#48c7ff',
      lineWidth: 1,
      opacity: 1
    },
    tocoReset: {
      color: '#ff729a',
      width: 7,
      height: 14,
      opacity: 1
    },
    fm: {
      color: '#00BD73FF',
      width: 5,
      height: 11,
      opacity: 1
    },
    autoFM: {
      color: '#8170FFFF',
      width: 5,
      height: 12,
      opacity: 1
    }
  }
}

export default function (key) {
  return config[key + '']
}
